import { GroupChannel } from '@sendbird/uikit-react/GroupChannel';
import CustomChannelHeader from '../CustomChannelHeader';
import * as S from '@styles/chat/chat.style';
import { useEffect, useRef } from 'react';
import { DateTime } from 'luxon';
import CustomMessage from '../CustomMessage';
import GroupChannelFooter from './GroupChannelFooter';
import { useGroupChannel } from '@sendbird/uikit-react/GroupChannel/context';
import { useUserInfoQuery } from '@apis/query/user';
import { useQuery } from 'react-query';
import { getStudentInfo } from '@apis/api/dashboard';
import _ from 'lodash';
import { addTypeChannelMetaData } from '@asset/function/chat';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useChatStore } from '@store/chat';
import { useSendbirdStateContext } from '@sendbird/uikit-react';
import { UserEventHandler } from '@sendbird/chat';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomGroupChannel = ({
  onCloseGroupChannel,
  openScheduledMessageFormPopup
}) => {
  const {
    data: user
  } = useUserInfoQuery();
  const {
    selectedChannel,
    setUnreadCount
  } = useChatStore();
  const {
    stores
  } = useSendbirdStateContext();
  const {
    state: {
      currentChannel
    }
  } = useGroupChannel();
  const channelInputRef = useRef(null);
  const {
    data: selectedChannelMetaData
  } = useQuery(['GET_CHANNEL_META_DATA', currentChannel?.url], async () => {
    return await currentChannel.getAllMetaData().then(response => {
      return addTypeChannelMetaData(response);
    }).catch(() => null);
  }, {
    enabled: !!currentChannel
  });
  const {
    data: studentInfo
  } = useQuery(['GET_STUDENT_INFO', selectedChannelMetaData], async () => await getStudentInfo(Number(selectedChannelMetaData.studentId)), {
    enabled: !_.isNil(selectedChannelMetaData?.studentId)
  });
  useEffect(() => {
    const userEventHandler = new UserEventHandler({
      onTotalUnreadMessageCountChanged: unreadMessageCount => {
        setUnreadCount(unreadMessageCount.groupChannelCount);
      }
    });
    if (stores?.sdkStore?.sdk?.addUserEventHandler) {
      stores?.sdkStore?.sdk?.addUserEventHandler('onTotalUnreadMessageCountUpdated', userEventHandler);
    }
    return () => {
      if (stores?.sdkStore?.sdk?.removeUserEventHandler) {
        stores?.sdkStore?.sdk?.removeUserEventHandler('onTotalUnreadMessageCountUpdated');
      }
    };
  }, [stores?.sdkStore?.sdk?.addUserEventHandler]);
  if (!_.isNil(studentInfo)) {
    return /*#__PURE__*/_jsx("div", {
      className: "w-full h-full",
      children: /*#__PURE__*/_jsx(GroupChannel, {
        channelUrl: selectedChannel.url,
        renderChannelHeader: props => /*#__PURE__*/_jsx(CustomChannelHeader, {
          GroupChannelHeaderProps: props,
          studentInfo: studentInfo,
          onCloseGroupChannel: onCloseGroupChannel
        }),
        renderCustomSeparator: props => /*#__PURE__*/_jsx(S.ChatSeparator, {
          children: DateTime.fromMillis(props.message.createdAt).toFormat('yyyy년 MM월 dd일 cccc', {
            locale: user.language ?? 'ko'
          })
        }),
        renderMessage: props => /*#__PURE__*/_jsx(CustomMessage, {
          messageProps: props,
          studentInfo: studentInfo,
          channelInputRef: channelInputRef
        }),
        renderMessageInput: () => /*#__PURE__*/_jsx(GoogleOAuthProvider, {
          clientId: process.env.NEXT_PUBLIC_GOOGLE_OAUTH_CLIENT_ID,
          children: /*#__PURE__*/_jsx(GroupChannelFooter, {
            channelInputRef: channelInputRef,
            openScheduledMessageFormPopup: channel => openScheduledMessageFormPopup(channel)
          })
        })
      })
    });
  }
};
export default CustomGroupChannel;